export enum TStorageNames {
  user = 'user',
  amplifyUser = 'amplifyUser',
  tenantId = 'tenantId',
  viaEmail = 'viaEmail',
  leasePacketCode = 'leasePacketCode',
  isBlocked = 'isBlocked',
  isVisitationBlocked = 'isVisitationBlocked',
  goToNextVideo = 'goToNextVideo',
  amplifyAutoSignIn = 'amplify-auto-sign-in',
  invitedUsername = 'invitedUsername',
  outgoingUsername = 'outgoingUsername',
}

type TStorage = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getItem: (key: TStorageNames) => any; // Todo: find solution
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem: (key: TStorageNames, value: any) => void; // Todo: find solution
  removeItem: (key: TStorageNames) => void;
  clear: () => void;
};

const oppLocalStorage: TStorage = {
  getItem: key => {
    try {
      const item = localStorage.getItem(key);
      if (item === null) return null;
      try {
        return JSON.parse(item);
      } catch {
        return item; // Return raw string for backward compatibility
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Silently fail — quota exceeded or restricted localStorage
    }
  },
  removeItem: key => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  },
  clear: () => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  },
};

// Tab-scoped, for state that must survive a reload but must not outlive the tab.
// The invited sign-in is the case: a visitor who reloads mid switch has to keep
// deferring to the invited account, but a visitor who closes the tab has
// abandoned the switch and should come back to ordinary behaviour.
const oppSessionStorage: TStorage = {
  getItem: key => {
    try {
      const item = sessionStorage.getItem(key);
      if (item === null) return null;
      try {
        return JSON.parse(item);
      } catch {
        return item;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Silently fail — quota exceeded or restricted sessionStorage
    }
  },
  removeItem: key => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  },
  clear: () => {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error(error);
    }
  },
};

export { oppLocalStorage, oppSessionStorage };
